import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "9 11 12 14 22 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "CheckSquare";
const CheckSquare = memo(themed(Icon));
export {
  CheckSquare
};
//# sourceMappingURL=check-square.js.map
